import clsx from "clsx";

import MigiriLogo from "../../components/svg/MigiriLogo.tsx";
import { FeaturesList } from "../../components/FeaturesList/FeaturesList.tsx";
import { useWindowResizeListener } from "../../hooks/useWindowResizeListener.ts";
import { SubscriptionData } from "../../lib/mappers/subscriptionData.ts";
import { ButtonVariant } from "../../lib/types.ts";

import PaymentCard from "../FreeTrial/PaymentCard.tsx";
import StartTrialButton from "../FreeTrial/StartTrialButton.tsx";
import FreeTrialCard from "../FreeTrial/FreeTrialCard.tsx";
import "./FreeTrialExternalPayment.css";

const FreeTrialExternalPayment = ({
  freeTrialActive,
  subscriptionData,
  checkoutUrl,
}: {
  freeTrialActive: boolean;
  subscriptionData: SubscriptionData;
  checkoutUrl: string;
}) => {
  const isDesktop = useWindowResizeListener()

  return (
    <>
      <div className="slanted-reflection-wrapper">
        <div className="slanted-reflection" />
      </div>

      <div className={clsx("FreeTrialExternalPaymentPage", "free-trial-content", "content")}>
        <div className="contentWrapper">
          <div className="infoSection">
            <div className="migiriLogo">
              <MigiriLogo />
            </div>
            <h2 className="semibold">
              {freeTrialActive
                ? "Your first week is on us"
                : "Give yourself the chance to transform your life"}
            </h2>

            <FeaturesList />

            {!isDesktop && subscriptionData.isPaymentRequired() && (
              <PaymentCard paymentData={subscriptionData.getPaymentData()} />
            )}

            {!isDesktop && !subscriptionData.isPaymentRequired() && (
              <FreeTrialCard
                freeDays={subscriptionData.getDaysAmount()}
                paymentData={subscriptionData.getPaymentData()}
                freeTrialActive={freeTrialActive}
              />
            )}
          </div>

          <div className="paymentSection">
            {isDesktop && subscriptionData.isPaymentRequired() && (
              <PaymentCard paymentData={subscriptionData.getPaymentData()} />
            )}

            {isDesktop && !subscriptionData.isPaymentRequired() && (
              <FreeTrialCard
                freeDays={subscriptionData.getDaysAmount()}
                paymentData={subscriptionData.getPaymentData()}
                freeTrialActive={freeTrialActive}
              />
            )}

            <StartTrialButton
              freeTrialActive={!subscriptionData.isPaymentRequired()}
              variant={ButtonVariant.secondary}
              freeDays={!subscriptionData.isPaymentRequired() ? subscriptionData.getDaysAmount() : undefined}
              onClick={() => { window.location.href = checkoutUrl }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FreeTrialExternalPayment;
